var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "icon-stack set_favorite fs-xxl cursor-pointer",
          attrs: { id: "tooltip-target-1" },
          on: {
            click: function ($event) {
              return _vm.set_favorite()
            },
          },
        },
        [
          _c("i", {
            staticClass: "fas fa-star icon-stack-1x",
            class: {
              "color-danger-100": _vm.is_favorite,
              "color-white": !_vm.is_favorite,
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-tooltip",
        { attrs: { target: "tooltip-target-1", triggers: "hover" } },
        [_vm._v("\n         " + _vm._s(_vm.msg) + "\n     ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }